import { render, staticRenderFns } from "./topTips.vue?vue&type=template&id=0ff8bf96"
import script from "./topTips.vue?vue&type=script&lang=js"
export * from "./topTips.vue?vue&type=script&lang=js"
import style0 from "./topTips.vue?vue&type=style&index=0&id=0ff8bf96&prod&lang=css"
import style1 from "./topTips.vue?vue&type=style&index=1&id=0ff8bf96&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports